import { useEffect, useState } from "react";
import { AvailabitiesBinary } from "../../Utils/TimeSlotUtils";

export function CalendarSelection({ day, label, rowStart, dayAvailabilities,  onUserChange }: { day: string, label: string, rowStart: number, dayAvailabilities: AvailabitiesBinary, onUserChange: (day:string,index:number,isSelected:boolean) => void }) {
    const [selected, setSelected] = useState(false);
    const [useIsStart, setIsStart] = useState(true);
    const [useIsEnd, setIsEnd] = useState(true);


    const changeSelection = () => {
        setSelected(!selected);
        onUserChange(day, rowStart, !selected);
    }

    useEffect(() => {
        if (dayAvailabilities[day as keyof AvailabitiesBinary].charAt(rowStart - 1) === "1") {
            setIsStart(false);
        } else {
            setIsStart(true);
        }
        if (dayAvailabilities[day as keyof AvailabitiesBinary].charAt(rowStart + 1) === "1") {
            setIsEnd(false);
        } else {
            setIsEnd(true);
        }
        if (dayAvailabilities[day as keyof AvailabitiesBinary].charAt(rowStart) === "1") {
            setSelected(true);
        } else {
            setSelected(false);
        }
 
    }, [dayAvailabilities, day, rowStart]);

    const getStartTriangleCSS = () => {
        if (useIsStart) {
            return "ts-triangle-top-true";
        } else {
            return "ts-triangle-top-false";
        }
    }
    const getBottomTriangleCSS = () => {
        if (useIsEnd) {
            return "ts-triangle-bottom-true";
        } else {
            return "ts-triangle-bottom-false";
        }
    }
    const getGapSelectedCSS = () => {
        if (selected) {
            return "calendar-gap-selection-true";
        } else {
            return "calendar-gap-selection-false";
        }
    }

    return (
        <div className={"calendar-gap-selection relative row-span-1 " + getGapSelectedCSS() + " "} onClick={changeSelection}>
            <div className="time-header text-center p-2">
                {label}
            </div>
            <div className="absolute-0">
                <div className={"ts-triangle-top " + getStartTriangleCSS()}></div>
                <div className={"ts-triangle-bottom " + getBottomTriangleCSS()}></div>
            </div>
        </div>
    );
}